module.exports = "fonts/StayDreaming.woff";